import { render, staticRenderFns } from "./Seccion2View.vue?vue&type=template&id=41c3d2fd&"
import script from "./Seccion2View.vue?vue&type=script&lang=js&"
export * from "./Seccion2View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports